import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import keys from 'lodash/keys';
import forEach from 'lodash/forEach';
import find from 'lodash/find';
import get from 'lodash/get';
import template from 'lodash/template';
import map from 'lodash/map';
import flatMap from 'lodash/flatMap';
import values from 'lodash/values';
import compact from 'lodash/compact';
import SiteComponent from 'yoda-site-components/lib/components/SiteComponent/SiteComponent';
import ErrorBoundary from 'yoda-site-components/lib/components/ErrorBoundary/ErrorBoundary';
import Messages, {
    messagesLevels,
    messagesActions,
} from 'yoda-site-components/lib/components/Messages';
import AddToCartInterstitialLazy from 'yoda-checkout-components/lib/components/AddToCartInterstitial/AddToCartInterstitialLazy';
import Button from 'yoda-core-components/lib/components/Button';
import Loading from 'yoda-site-components/lib/components/Loading/Loading';
import LoaderAction from 'yoda-site-components/lib/actions/LoadingAction';
import ItemCountAction from 'yoda-site-components/lib/actions/ItemCountAction';
import selectPpId from 'yoda-site-components/lib/selectors/productDetails/selectPpId';
import getNumberOfDays from 'yoda-site-components/lib/dates/DateFormatter/GetNumberOfDays';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import YodaTooltipLazy from 'yoda-site-components/lib/components/YodaTooltip/YodaTooltipLazy';
import * as styles from './BundleAddToCart.css';
import { ADD_TO_CART_MESSAGES_ID, ADD_TO_CART_COMMON_MESSAGE_ID } from './BundleAddToCart.config';
import { addItemToCart, closeCartModal } from '../../../actions/AddToCartAction';
import {
    carePlanViewAnalytics,
    carePlanAcceptAnalytics,
    openModalAnalytics,
    bundleCartAddAnalytics,
} from '../../../actions/AnalyticsAction';
import {
    selectedProductsForBundles,
    selectSkuIds,
    getSelectedQunatity,
    getProductOptionsSelection,
} from '../../../selectors/Bundle/BundleProductOptionsSelector';
import { hasProtectionPlan as hasProtectionPlanSelector } from '../../../selectors/Bundle/BundleCommonSelector';
import getBundleInventoryStatus from '../../../selectors/Bundle/BundleInventorySelector';
import getBundleProductDeliveryDate from '../../../selectors/Bundle/BundleProductDeliveryDateSelector';
import ProductConstants from '../../../helpers/ProductConstants';
import withBundleSkuValidation from '../BundleSkuValidation/BundleSkuValidation';
import { scrollToFirstMessage } from '../../../helpers/AddToHelpers';
import getBundleProductDeliveryType from '../../../selectors/Bundle/BundleProductDeliveryTypeSelector';

const cx = classNames.bind(styles);
const tooltipStyle = { width: 180 };

let addToCartData = [];
let carePlanAnalyticsData = [];

export class BundleAddToCart extends SiteComponent {
    static propTypes = {
        automationId: PropTypes.string,
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        addToCart: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        productDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        selectedBundleSkus: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        deliveryDate: PropTypes.oneOfType([PropTypes.object]),
        deliveryZipcode: PropTypes.string,
        addToCartMessages: PropTypes.oneOfType([PropTypes.array]),
        selectedProtectionPlan: PropTypes.oneOfType([PropTypes.object]),
        messagesTexts: PropTypes.oneOfType([PropTypes.object]),
        bundleQuantity: PropTypes.oneOfType([PropTypes.object]),
        bundlePrice: PropTypes.oneOfType([PropTypes.object]),
        isEveryDimensionSelected: PropTypes.bool,
        selectedSkuIds: PropTypes.oneOfType([PropTypes.array]),
        totalProductQty: PropTypes.number,
        getBundleSkuValidation: PropTypes.func,
        getBundleInventory: PropTypes.object,
    };

    static defaultProps = {
        automationId: '',
        actions: {},
        addToCart: {
            isAddToCartSuccess: false,
            isUpdateCartSuccess: false,
        },
        productDetails: {},
        selectedBundleSkus: {},
        deliveryDate: {},
        deliveryZipcode: '',
        addToCartMessages: [],
        selectedProtectionPlan: {},
        messagesTexts: {},
        bundleQuantity: {},
        bundlePrice: {},
        isEveryDimensionSelected: false,
        selectedSkuIds: [],
        totalProductQty: 0,
        getBundleSkuValidation: null,
        getBundleInventory: {},
    };

    state = {
        tooltipEnabled: this.props.deviceType && this.props.deviceType.isDesktop,
        showSelectOptionTooltip: false,
        isValidationFailed: false,
    };

    componentWillReceiveProps(nextProps) {
        /* istanbul ignore next  */
        if (nextProps.addToCart.isAddToCartSuccess && !this.props.addToCart.isAddToCartSuccess) {
            this.triggerCartAddAnalytics(addToCartData);
        }
    }

    prepareCarePlanAcceptAnalyticsData = (selectedSKU = '', ppId, isFromInterstitial) => {
        const {
            selectedBundleSkus,
            productDetails: { products = [] },
        } = this.props;

        let bundleItemPpId = ppId;

        /* istanbul ignore next */
        if (isFromInterstitial && products && products.length) {
            const item = products.filter((product) => product.id === ppId);
            bundleItemPpId = item[0].base.id;
        }

        const warrantyPrice =
            selectedBundleSkus &&
            find(selectedBundleSkus[bundleItemPpId].selectedProductLot[0].warranties, {
                itemId: selectedSKU,
            });
        const lotId = selectedSKU.slice(0, 7);
        /* istanbul ignore next */
        const productInfo = {
            productLotId: [lotId],
            productPPID: bundleItemPpId,
            productSKU: selectedSKU,
            productCurrentSellingPrice:
                warrantyPrice && warrantyPrice.price
                    ? Number(warrantyPrice.price).toFixed(2)
                    : '0.00',
        };

        /* istanbul ignore next */
        if (isFromInterstitial) {
            this.props.actions.carePlanAcceptAnalytics([{ productInfo }]);
        } else {
            carePlanAnalyticsData.push({ productInfo });
        }
    };

    triggerCartAddAnalytics = (cartItems) => {
        const {
            bundleDeliveryDateForAnalytics = {},
            bundleDeliveryTypeForAnalytics = {},
            actions,
        } = this.props;
        const clickPosition = 'add to bag|pdp|main';

        actions.bundleCartAddAnalytics({
            deliveryMethod: 'ship to home',
            cartItems,
            clickPosition,
            bundleDeliveryDateForAnalytics,
            bundleDeliveryTypeForAnalytics,
        });
        actions.openModalAnalytics('cart interstitial');
    };

    removeLoader = () => {
        this.props.actions.removeLoader();
    };

    getChildItems(ppId) {
        const { selectedProtectionPlan, bundleQuantity } = this.props;
        const childItems = [];
        /* istanbul ignore else */
        if (selectedProtectionPlan[ppId] && selectedProtectionPlan[ppId] !== 'no') {
            const quantity = bundleQuantity[ppId] ? bundleQuantity[ppId] : 1;
            childItems.push({
                skuId: selectedProtectionPlan[ppId],
                ppId,
                quantity,
            });
            this.prepareCarePlanAcceptAnalyticsData(selectedProtectionPlan[ppId], ppId);
        }
        return childItems;
    }

    addToCart = (allSkus) => {
        const { bundleQuantity, productDetails, hasProtectionPlan } = this.props;
        addToCartData = [];
        const cartItemsToAdd = [];
        allSkus.forEach(({ skuId, ppId, id }) => {
            const cartDetails = {};
            cartDetails.skuId = skuId;
            cartDetails.quantity = bundleQuantity[ppId];
            cartDetails.ppId = ppId;
            cartDetails.childItems = this.getChildItems(ppId);
            const cartItemDetails = { ...cartDetails, ppId: id };
            addToCartData.push(cartDetails);
            cartItemsToAdd.push(cartItemDetails);
        });
        if (carePlanAnalyticsData.length) {
            const carePlanViewData = [].concat(carePlanAnalyticsData).map((item) => ({
                productInfo: {
                    productLotId: item.productInfo.productLotId,
                    productPPID: item.productInfo.productPPID,
                },
            }));
            this.props.actions.carePlanViewAnalytics(carePlanViewData);
            this.props.actions.carePlanAcceptAnalytics(carePlanAnalyticsData);
        } else if (hasProtectionPlan) {
            this.props.actions.carePlanViewAnalytics([
                { productInfo: { productPPID: productDetails.id } },
            ]);
        }
        this.setState({
            isValidationFailed: false,
        });
        this.props.actions.addItemToCart({ data: cartItemsToAdd, interstitial: true });
    };

    getBundleDeliveryDateAnalytics() {
        const { deliveryZipcode: zipCode, deliveryDate } = this.props;
        const bundleDeliveryDate = get(deliveryDate, [zipCode]);
        const getAllDeliveryDate = compact(
            map(flatMap(bundleDeliveryDate, values), 'earliestDeliveryDate')
        );

        let deliveryDays = '';
        let deliveryDayType = '';

        if (getAllDeliveryDate.length) {
            const earliestDeliveryDate = getAllDeliveryDate.filter(Boolean).sort().reverse()[0];
            deliveryDays = getNumberOfDays(earliestDeliveryDate);
            deliveryDayType = 'single';
        }

        return {
            deliveryDays,
            deliveryDayType,
        };
    }

    onAddToCartClick = () => {
        const {
            productDetails,
            selectedBundleSkus,
            bundleQuantity,
            messagesTexts: { AddToCartMessages },
            bundleInventoryStatus = {},
            getBundleSkuValidation,
            actions,
            getBundleInventory,
        } = this.props;
        const triggerFormErrorAnalytics = true; // MPDPYODA-4379 fix
        const addToCartFormValidationResult =
            getBundleSkuValidation(triggerFormErrorAnalytics) || {};

        /* istanbul ignore next  */
        if (!addToCartFormValidationResult.isEverySKUSelected) {
            this.setState({
                isValidationFailed: true,
            });
            document.activeElement.blur();
            actions.addMessage({
                section: ADD_TO_CART_MESSAGES_ID,
                message: {
                    id: ADD_TO_CART_COMMON_MESSAGE_ID,
                    title: ProductConstants.ADD_TO_CART_SELECTION,
                    type: 'warning',
                },
            });
            addToCartFormValidationResult.validationResult &&
                Object.keys(addToCartFormValidationResult.validationResult).forEach((ppID) => {
                    const {
                        isValid,
                        messages = [],
                    } = addToCartFormValidationResult.validationResult[ppID];
                    if (!isValid && messages.length) {
                        messages.forEach((message) => {
                            message.sourceMiniPDP = false;
                            message.type = 'warning';
                            actions.addMessage(message);
                        });
                    }
                });
            setImmediate(scrollToFirstMessage);
            return null;
        }
        /* istanbul ignore next  */
        if (!getBundleInventory.isEveryInventoryAvailable) {
            this.props.actions.addMessage({
                section: ADD_TO_CART_MESSAGES_ID,
                message: {
                    id: ADD_TO_CART_COMMON_MESSAGE_ID,
                    title:
                        'Some of your items are not available in the quantity you selected. Please change quantity to continue.',
                    type: 'warning',
                },
            });
            bundleInventoryStatus.inventoryStatus &&
                Object.keys(bundleInventoryStatus.inventoryStatus).forEach((ppID) => {
                    const { inventoryErrorMessage = {} } = bundleInventoryStatus.inventoryStatus[
                        ppID
                    ];
                    /* istanbul ignore else  */
                    if (Object.keys(inventoryErrorMessage).length) {
                        this.props.actions.addMessage(inventoryErrorMessage);
                    }
                });
            setImmediate(scrollToFirstMessage);
            return null;
        }

        const bundlesSkusOutOfStock = [];
        const allSkus = [];
        /* istanbul ignore next  */
        if (productDetails.products) {
            let skuId;
            productDetails.products.forEach((product) => {
                skuId = selectedBundleSkus[product.base.id];
                /* istanbul ignore else  */
                if (bundleQuantity[product.base.id] && skuId.isItemInStock) {
                    if (skuId.filteredItems && skuId.filteredItems.length > 0) {
                        allSkus.push({
                            skuId: skuId.filteredItems[0].id,
                            ppId: product.base.id,
                            id: product.id,
                        });
                    }
                } else {
                    bundlesSkusOutOfStock.push(skuId);
                }
            });
            if (productDetails.products.length === allSkus.length + bundlesSkusOutOfStock.length) {
                this.props.actions.showLoader();
                this.addToCart(allSkus);
            } else {
                this.props.actions.addMessage({
                    section: ADD_TO_CART_MESSAGES_ID,
                    message: {
                        id: ADD_TO_CART_COMMON_MESSAGE_ID,
                        title: AddToCartMessages.inventoryUnavailable,
                        type: 'warning',
                    },
                });
                // trigger form errors for product options
            }
        }
        return null;
    };

    closeCartModal = () => {
        this.props.actions.updateItemCountAction();
        this.props.actions.closeCartModal({ stickyHeaderOnClick: false });
        carePlanAnalyticsData = [];
    };

    checkItemAvailability = () => {
        let isItemAvailable = false;
        const { deliveryZipcode, deliveryDate, bundleQuantity } = this.props;
        const deliveryDateZip = deliveryDate[deliveryZipcode];
        if (!isEmpty(deliveryDateZip)) {
            forEach(deliveryDateZip, (value) => {
                const valueKeys = keys(value);
                /* istanbul ignore else */
                if (value[valueKeys[0]] && !value[valueKeys[0]].isFetching) {
                    isItemAvailable = !isItemAvailable
                        ? value[valueKeys[0]].available && value[valueKeys[0]].earliestDeliveryDate
                        : isItemAvailable;
                } else {
                    isItemAvailable = true;
                }
            });
        } else {
            forEach(bundleQuantity, (value) => {
                isItemAvailable = !isItemAvailable ? !!value : isItemAvailable;
            });
        }
        return isItemAvailable;
    };

    getItemsQuantity = () => {
        const { bundleQuantity = [] } = this.props;

        if (Object.values(bundleQuantity).length) {
            return Object.values(bundleQuantity).reduce((acc, value) => acc + value);
        }

        return 0;
    };

    renderCartSuccessModal() {
        return (
            <ErrorBoundary>
                <AddToCartInterstitialLazy
                    sku={this.props.selectedSkuIds}
                    showAddToCart={this.props.addToCart.isAddToCartSuccess}
                    ppId={this.props.ppId}
                    onCloseAddToCart={this.closeCartModal}
                    numberOfItems={this.getItemsQuantity()}
                    careplanAcceptAnalyticsFunc={this.prepareCarePlanAcceptAnalyticsData}
                    removeLoader={this.removeLoader}
                />
            </ErrorBoundary>
        );
    }

    getTooltipContent = () => {
        const { deviceType = {} } = this.props;
        let tooltipEnabled = false;
        let tooltipMessage = null;
        if (deviceType.isDesktop && this.state.showSelectOptionTooltip) {
            tooltipEnabled = true;
            tooltipMessage = ProductConstants.ADD_TO_CART_SELECTION;
        }
        return {
            enabled: tooltipEnabled,
            message: tooltipMessage,
        };
    };

    getATCButtonContainerRef = (ref) => {
        this.addToCartButtonContainer = ref;
    };

    getATCButtonBlockRef = (ref) => {
        this.addToCartButtonBlock = ref;
    };

    onSearchHover = () => {
        const { isEveryDimensionSelected } = this.props;
        this.setState({ showSelectOptionTooltip: !isEveryDimensionSelected });
    };

    render() {
        const {
            addToCartMessages,
            addToCart,
            automationId,
            totalProductQty,
            deviceType,
        } = this.props;
        const tooltipContent = this.getTooltipContent();
        const { isValidationFailed } = this.state;
        /* istanbul ignore next */
        if (addToCartMessages) {
            addToCartMessages.forEach((message) => {
                message.type = 'warning';
            });
        }
        const bundleAddtoCartStyle = dt(['!p-0']);
        const toolTipContainerStyle = dt(['!block']);
        const buttonContainerStyle = dt(['mt-4', 'mb-10', 'mx-0']);
        const addToCartMessageStyle = dt([
            'lg:mt-2',
            'smOnly:mt-2',
            'whitespace-normal',
            'text-left',
            'mdOnly:mt-2',
        ]);
        return (
            <div
                className={cx(
                    'wrapper',
                    'sm12',
                    'md12',
                    'lg7',
                    'xl7',
                    'bundleAddtoCart',
                    bundleAddtoCartStyle
                )}
            >
                <div
                    data-automation-id="buttonContainer"
                    className={buttonContainerStyle}
                    ref={this.getATCButtonContainerRef}
                >
                    <YodaTooltipLazy
                        tooltipBodyClassName={dt(['w-full'])}
                        className={cx('toolTipContainer', toolTipContainerStyle)}
                        renderTooltipContents={
                            <div style={tooltipStyle}>{tooltipContent.message}</div>
                        }
                        delay={[0, 3000]}
                        disabled={!tooltipContent.enabled}
                        tooltipContentClass={dt([
                            '!bg-black',
                            '!p-3',
                            '!rounded-xl',
                            '!text-white',
                            '!border-black',
                        ])}
                        direction="Topright"
                        tooltipPlacement="Left"
                        tooltipType="link"
                    >
                        <div
                            data-automation-id="addToCartBlock"
                            className={cx('addToCartBlock')}
                            ref={this.getATCButtonBlockRef}
                            onMouseOver={this.onSearchHover}
                        >
                            <div
                                data-automation-id="addToCartMessage"
                                className={addToCartMessageStyle}
                            >
                                <Messages
                                    level={messagesLevels.inline}
                                    messages={addToCartMessages}
                                    hasClose={false}
                                />
                            </div>
                            <Button
                                size="Lg"
                                automationId={automationId}
                                className={`${cx({
                                    addToCartBtn: true,
                                    addToCartHover: isValidationFailed && !deviceType.isDesktop,
                                })} ${dt(['sm:w-full'])}`}
                                isDisabled={!this.checkItemAvailability()}
                                onClick={this.onAddToCartClick}
                            >
                                <span className={cx('btnText')}>
                                    {template(ProductConstants.ADD_ITEMS_TO_CART)({
                                        qty: totalProductQty,
                                    })}
                                </span>
                            </Button>
                        </div>
                    </YodaTooltipLazy>
                </div>
                {addToCart.isAddToCartSuccess ? this.renderCartSuccessModal() : null}
                <Loading />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    addToCart: state.addToCart,
    selectedBundleSkus: selectedProductsForBundles(state),
    deliveryDate: state.bundleDeliveryDate,
    productDetails: state.productDetails,
    deliveryZipcode: state.deliveryZipcode,
    addToCartMessages: state.messages[ADD_TO_CART_MESSAGES_ID],
    selectedProtectionPlan: state.bundleProtectionPlan,
    messagesTexts: state.context.messagesTexts,
    bundleQuantity: state.bundleQuantity,
    bundlePrice: state.bundlePrice,
    deviceType: state.context ? state.context.deviceType : {},
    selectedSkuIds: selectSkuIds(state, true),
    ppId: selectPpId(state),
    totalProductQty: getSelectedQunatity(state),
    bundleInventoryStatus: getBundleInventoryStatus(state),
    hasProtectionPlan: hasProtectionPlanSelector(state),
    isEveryDimensionSelected: getProductOptionsSelection(state).isEveryDimensionSelected,
    getBundleInventory: getBundleInventoryStatus(state),
    bundleDeliveryDateForAnalytics: getBundleProductDeliveryDate(state),
    bundleDeliveryTypeForAnalytics: getBundleProductDeliveryType(state),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            ...messagesActions,
            ...LoaderAction,
            ...ItemCountAction,
            /* Add To Cart Actions */
            addItemToCart,
            closeCartModal,
            carePlanViewAnalytics,
            carePlanAcceptAnalytics,
            openModalAnalytics,
            bundleCartAddAnalytics,
        },
        dispatch
    ),
});

export default compose(
    withBundleSkuValidation(),
    connect(mapStateToProps, mapDispatchToProps)
)(BundleAddToCart);
